export const environment = {
    production: true,
    defaultLanguage: 'en',
    // @ts-ignore
    providers: [],
};
